export default __webpack_public_path__ + "static/media/clients.2235373d.svg";